<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Registration Card"
    seFeDataSubtitle="Open registration card for MySE registration discovery"
    size="750">
  </se-fe-header>

  <div seFePageContent>
    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-open-registration-card-example></se-open-registration-card-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
